import { memo } from "react";
import { validators } from "investira.sdk";

/**
 * Renderiza o componente VerifyValue.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {number} props.value - Valor exibido ou controlado pelo componente.
 * @param {Object} props.content - Conteúdo exibido pelo componente.
 * @returns {JSX.Element|null} Elemento renderizado ou `null` quando não houver conteúdo para exibir.
 */
const VerifyValue = memo(props => {
  console.log(props);
  const {
    value,
    content
  } = props;
  console.log(value);
  if (validators.isEmpty(value)) {
    return null;
  }
  return content;
  //return children;
});
VerifyValue.propTypes = {
  //value: PropTypes.any,
};
VerifyValue.displayName = "VerifyValue";
export default VerifyValue;
